
























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { State, Getter, Action, Mutation, namespace } from "vuex-class";
import {
  pagination,
  loadingCatch,
  loading,
  SearchbarControl,
  IsMore,
} from "@root/lib/decorator";
import add from "./add.vue";

const scan = namespace("scan");

@Component({ components: { add } })
@pagination("getData", {
  pageSize: 50,
})
@SearchbarControl()
@loading()
@IsMore(true)
export default class userManagerPage extends Vue {
  @scan.Action querySupplierScanRecordDetail;
  @scan.Action queryCustomerLevelList;
  @scan.Action getCustomerLevelDetail;
  @scan.Action queryCustomerLevelBaseStorePage;
  @scan.Action deleteCustomerLevel;
  @scan.Action exportCustomerLevelStore;

  private isExportDialogVisible: boolean = false;
  private dataList = [];
  private loading: boolean = false;
  private currentItem: any = null;

  isEdit: boolean = false;
  editData: any = null;
  isLoginUser(d) {
    const userInfoStr = localStorage.getItem("userInfo"),
      userInfo = JSON.parse(userInfoStr || "{}"),
      { userCode } = userInfo;

    return userCode === d;
  }
  isOaCooperation: any = '';
  async mounted() {
    this.isOaCooperation = localStorage.getItem("isOaCooperation");
    await this.getData();
  }

  @loadingCatch
  async getData() {
    try {
      this.loading = true;
      let data = await this.queryCustomerLevelList();
      this.dataList = data;
    } catch {
      //
    } finally {
      this.loading = false;
    }
  }
  async handleDelete(data) {
    try {
      await this.$confirm("你确定要删除吗？");
      await this.deleteCustomerLevel({
        levelId: data.id,
      });
      this.$message({ type: "success", message: "删除成功" });
      (this as any).currentPage = 1;
      this.loading = true;
      setTimeout(() => {
        this.getData();
      }, 1500);
    } catch (error) {
      console.log(error);
    }
  }
  async handleExport(data) {
    this.currentItem = data;
    this.isExportDialogVisible = true;
  }
  async exportFileFn() {
    await this.exportCustomerLevelStore({ levelId: this.currentItem.id });
  }
  handleAdd() {
    this.isEdit = false;
    (this as any).$refs.add.dialogVisible = true;
    this.editData = null;
  }
  handleEdit(row) {
    this.getItemDetail(row).then(() => {
      this.isEdit = true;
      (this as any).$refs.add.dialogVisible = true;
    });
  }
  async getItemDetail(row) {
    let data = await this.getCustomerLevelDetail({ levelId: row.id });
    this.editData = data;
  }
  refresh() {
    this.loading = true;
    setTimeout(() => {
      this.getData();
    }, 1500);
  }
}
